var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyecloseimg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3592_10295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9736 15.9579C13.5468 17.0455 11.8095 17.648 10.0157 17.6773C4.17311 17.6773 0.834473 11 0.834473 11C1.8727 9.06522 3.31269 7.3748 5.05785 6.04217M8.26294 4.52309C8.83746 4.38861 9.42567 4.32139 10.0157 4.32277C15.8583 4.32277 19.197 11 19.197 11C18.6903 11.9479 18.0861 12.8403 17.3941 13.6626M11.7852 12.7695C11.556 13.0155 11.2795 13.2129 10.9724 13.3497C10.6652 13.4866 10.3336 13.5602 9.99744 13.5661C9.66123 13.572 9.32727 13.5102 9.01548 13.3842C8.70369 13.2583 8.42046 13.0709 8.18269 12.8331C7.94491 12.5953 7.75747 12.3121 7.63153 12.0003C7.50559 11.6885 7.44374 11.3545 7.44968 11.0183C7.45561 10.6821 7.5292 10.3506 7.66606 10.0434C7.80291 9.73625 8.00023 9.45981 8.24625 9.23057",
    stroke: "#E52333",
    strokeWidth: 1.66932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.834473 1.81885L19.197 20.1814",
    stroke: "#E52333",
    strokeWidth: 1.66932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3592_10295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0318,
    height: 20.0318,
    fill: "white",
    transform: "translate(0 0.984131)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyecloseimg);
export default __webpack_public_path__ + "static/media/eyecloseimg.8961fc5b3ec2d62c58afbec43567dae1.svg";
export { ForwardRef as ReactComponent };